// import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";
// import { refreshAccessToken } from "./Apis";

// const axiosInstance: AxiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   // , withCredentials: true
// });

// axiosInstance.interceptors.response.use(
//   (response: AxiosResponse) => response?.data || response,
//   async (error: any) => {
//     const originalRequest: any = error.config;
//     // If access token has expired, refresh it
//     if (
//       error?.response &&
//       error.response.status === 403 &&
//       !originalRequest._retry
//     ) {
//       originalRequest._retry = true;
//       let refreshTokenRes: any = null;
//       if (error.response.data.message === "Token Expired") {
//         refreshTokenRes = await refreshAccessToken();
//         if (refreshTokenRes.status === true) {
//           localStorage.setItem("accessToken", refreshTokenRes.data.token);
//           originalRequest.headers["Authorization"] = refreshTokenRes.data.token;
//           return axiosInstance(originalRequest); // Retry the original request with the new token
//         }
//         else{
//           localStorage.removeItem("accessToken");
//           localStorage.removeItem("refreshToken");
//           window.location.reload()
//         }
//       } else if (error.response.data.message === "Refresh Token Expired") {
//         localStorage.removeItem("accessToken");
//         localStorage.removeItem("refreshToken");
//         window.location.reload()
//       }
//     }
//     return Promise.reject(
//       (error.response && error.response.data) || "Something went wrong!"
//     );
//   }
// );

// // axiosInstance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// export default axiosInstance;







import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";
import { toast } from "react-toastify";
import { refreshAccessToken } from "./Apis";

const axiosInstance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // , withCredentials: true
});

// Shared so parallel 403s wait on a single refresh instead of each rotating the refresh token
let refreshPromise: Promise<any> | null = null;

const ACCOUNT_DISABLED_MESSAGES = [
  "Your account is inactive. Please contact admin.",
  "Your account is blocked. Please contact admin.",
];
const FORCED_LOGOUT_MESSAGES = [
  "You’ve been logged out since your account was signed in from another device.",
  "You’ve been logged out. Please login again",
];

const clearSessionAndReload = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  window.location.reload();
};

// Backend may report auth errors either as an HTTP status or as `code` in a 200 body (as the mobile app handles)
// Returns the retried response when the token was refreshed, otherwise undefined.
const handleAuthError = async (code: any, message: any, request: any) => {
  if (!request || request._retry || request.url?.includes("/admin/token")) return;

  if (code == 401 && ACCOUNT_DISABLED_MESSAGES.includes(message)) {
    if (localStorage.getItem("accessToken")) clearSessionAndReload();
    return;
  }
  if (code != 403) return;

  if (message === "Token Expired") {
    request._retry = true;
    if (!refreshPromise) {
      refreshPromise = refreshAccessToken().finally(() => {
        refreshPromise = null;
      });
    }
    const refreshTokenRes: any = await refreshPromise;
    // "Refresh Token Expired" comes back with status: true and data: "Forbidden", so require a real token
    const { token, refreshToken } =
      typeof refreshTokenRes?.data === "object" && refreshTokenRes?.data
        ? refreshTokenRes.data
        : ({} as any);
    if (refreshTokenRes?.status === true && refreshTokenRes?.code != 403 && token) {
      localStorage.setItem("accessToken", token);
      if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
      // Default header is set once at login/init; keep it in sync so later calls use the new token
      axiosInstance.defaults.headers.common["Authorization"] = token;
      request.headers["Authorization"] = token;
      return axiosInstance(request); // Retry the original request with the new token
    }
    clearSessionAndReload();
  } else if (message === "Refresh Token Expired") {
    clearSessionAndReload();
  } else if (FORCED_LOGOUT_MESSAGES.includes(message)) {
    toast.error(message);
    setTimeout(clearSessionAndReload, 3000);
  }
};

axiosInstance.interceptors.response.use(
  async (response: AxiosResponse) => {
    const body: any = response?.data;
    const retried = await handleAuthError(body?.code, body?.message, response?.config);
    if (retried) return retried;
    return body || response;
  },
  async (error: any) => {
    const body: any = error?.response?.data;
    const retried = await handleAuthError(
      error?.response?.status ?? body?.code,
      body?.message,
      error?.config
    );
    if (retried) return retried;
    return Promise.reject(body || "Something went wrong!");
  }
);

// axiosInstance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export default axiosInstance;
